import React from 'react';
const rows = [{
  tried: 'Pinterest and saved reels',
  gave: 'The finished photo. Zero words.',
  gives: 'The exact words that get you there in 40 seconds'
}, {
  tried: 'A prompt app',
  gave: 'Your phone in your hand — and prompts your couples already saw on TikTok',
  gives: 'Printable, memorizable, yours'
}, {
  tried: 'YouTube',
  gave: 'Fragments. No sequence, no clock.',
  gives: 'Part by part, with the minutes attached'
}, {
  tried: 'A $1,500 workshop',
  gave: 'One model couple, perfect light, zero chaos',
  gives: 'Rain, flat light, a lost aunt, a church with restrictions'
}, {
  tried: '“Experience”',
  gave: 'The most expensive teacher there is — it charges in soft galleries',
  gives: 'The system, without paying the tuition'
}];
export function Comparison() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-82" data-mp="9lyyp5r54j3r">
      <div className="mx-auto max-w-5xl px-5" data-id="element-83" data-mp="ek0dhehj9w9f">
        <h2 className="text-center font-serif text-3xl sm:text-4xl text-ink" data-id="element-84" data-mp="eksbevyls62v">
          What you&rsquo;ve probably already tried
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-85" data-mp="1h9qr4y50xt5f" />

        <div className="mt-12 overflow-hidden border border-gold-soft bg-white" data-id="element-86" data-mp="1d85khuj32b3o">
          <div className="hidden bg-gold-tint text-[11px] uppercase tracking-[0.18em] sm:grid sm:grid-cols-3" data-id="element-87" data-mp="1d6162ink5tp5">
            <div className="border-r border-gold-soft px-5 py-4 text-ink-soft" data-id="element-88" data-mp="24zl89rwdm3vh">
              You tried
            </div>
            <div className="border-r border-gold-soft px-5 py-4 text-ink-soft" data-id="element-89" data-mp="20xq50huvxgf2">
              What it gave you
            </div>
            <div className="px-5 py-4 text-gold-dark" data-id="element-90" data-mp="1vxbv0u9q3wee">What this gives you</div>
          </div>

          {rows.map((row, index) => <div key={row.tried} className={index > 0 ? 'border-t border-gold-soft/70' : 'sm:border-t-0'} data-id="element-91" data-mp="1r268pucesfps" data-mpi={index}>
              <div className="sm:grid sm:grid-cols-3" data-id="element-92" data-mp="fjlntenb4s0j">
                <h3 className="bg-gold-tint px-4 py-3 font-serif text-base text-ink sm:border-r sm:border-gold-soft/70 sm:bg-transparent sm:px-5 sm:py-5 sm:text-lg" data-id="element-93" data-mp="h1spzwhcr1ha">
                  {row.tried}
                </h3>

                <div className="grid grid-cols-2 sm:contents" data-id="element-94" data-mp="81nizng2m53n">
                  <div className="border-r border-gold-soft/70 px-4 py-4 sm:px-5 sm:py-5" data-id="element-95" data-mp="838hfo5ia86s">
                    <p className="text-[10px] uppercase tracking-[0.14em] text-ink-muted sm:hidden" data-id="element-96" data-mp="d2bkj31xe4c4">
                      Gave you
                    </p>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-ink-muted sm:mt-0 sm:text-[15px]" data-id="element-97" data-mp="32b0tg059m7e">
                      {row.gave}
                    </p>
                  </div>
                  <div className="bg-gold-tint/40 px-4 py-4 sm:px-5 sm:py-5" data-id="element-98" data-mp="3ph404lvb4icp">
                    <p className="text-[10px] uppercase tracking-[0.14em] text-gold-dark sm:hidden" data-id="element-99" data-mp="3bhuq63xp2kh6">
                      Gives you
                    </p>
                    <p className="mt-1.5 text-[13px] font-medium leading-relaxed text-ink sm:mt-0 sm:text-[15px]" data-id="element-100" data-mp="3ggecw6k440al">
                      {row.gives}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}